export default {
  // Add your English translations here
  "home.welcome": "Welcome",
  "nav.services": "Services",
  "nav.about": "About",
  "nav.contact": "Contact"
};
